
export type SolverObjectiveRankingModelOrderedCriteriaItem = typeof SolverObjectiveRankingModelOrderedCriteriaItem[keyof typeof SolverObjectiveRankingModelOrderedCriteriaItem];


export const SolverObjectiveRankingModelOrderedCriteriaItem = {
  MaximizePlacedArea: 'MaximizePlacedArea',
  MinimizeCost: 'MinimizeCost',
  MinimizeArticleCount: 'MinimizeArticleCount',
  MinimizeDistinctArticleTypes: 'MinimizeDistinctArticleTypes',
  MinimizeGapWidth: 'MinimizeGapWidth',
} as const;
